// @flow

import React from 'react';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import './NoRecord.scss';

export const NoRecord = ({ hint }: { hint?: string }) => (
  <div className="no-record">
    <span className="no-record__hint"><L10nMessage id={hint} /></span>
  </div>
);

NoRecord.defaultProps = {
  hint: 'global.noRecord',
};

export default NoRecord;
